<template>
  <span>
    <!-- 签到后各阶段均可重打作业单；出库单须完成储运确认。 -->
    <el-button v-if="hasAssignment && planId && ['3', '4', '5'].includes(status)" type="text" class="ml10"
               :disabled="exporting" @click="openPrint('WORK')">作业单</el-button>
    <el-button v-if="hasWarehouse && planId && status === '6' && ygType === 'A'" type="text" class="ml10"
               :disabled="exporting" @click="openPrint('OUTBOUND')">出库单</el-button>
  </span>
</template>

<script>
export default {
  name: 'PlanDocumentActions',
  props: {
    planId: { type: String, default: '' },
    status: { type: String, default: '' },
    ygType: { type: String, default: '' }
  },
  data() {
    return { exporting: false }
  },
  computed: {
    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasAssignment() {
      return this.buttonList.includes('assignment')
    },
    hasWarehouse() {
      return this.buttonList.includes('warehouse')
    }
  },
  methods: {
    async openPrint(documentType) {
      if (this.exporting) return
      this.exporting = true
      try {
        // 请求后端获取pdf链接 / blob
        const res = await this.$axios.post(this.$apis.clyy.exportDocument, {
          planId: this.planId,
          documentType
        }, {
          responseType: 'blob'
        })
        let pdfUrl = ''
        // 情况1：后端直接返回pdf在线地址
        if (typeof res === 'string') {
          pdfUrl = res
        } else if (res.data) {
          // 情况2：后端返回blob文件流，生成本地预览地址
          const blob = new Blob([res.data], { type: 'application/pdf' })
          pdfUrl = URL.createObjectURL(blob)
        }
        if (!pdfUrl) {
          this.$message.warn('获取打印文件失败')
          return
        }
        // 打开新窗口加载PDF，加载完成唤起打印面板
        const printWin = window.open(pdfUrl, '_blank')
        printWin.onload = function () {
          printWin.print()
        }
      } catch (err) {
        console.error('打印失败：', err)
        this.$message.error('打印预览失败')
      } finally {
        this.exporting = false
      }
    }
  }
}
</script>
